import type { ReturnInspection } from './inspections';
import { apiFetch } from './client';
import { garmentInspectionPath } from './queryPaths';
import type { toRequest } from '../returns/inspection';

/**
 * Records — or corrects — one garment's inspection, the request built by `toRequest`
 * (`returns/inspection.ts`). One definition for the website's return counter and the phone's
 * "check each garment", so the two cannot send the server different findings for one mark.
 *
 * <p>
 * The findings are replaced wholesale, never patched (CLAUDE.md, "Inspection, damage and jobs"):
 * an empty list is a real answer.
 * </p>
 */
export function saveInspection(rentalOrderItemId: number, request: ReturnType<typeof toRequest>) {
  return apiFetch<ReturnInspection>(garmentInspectionPath(rentalOrderItemId), {
    method: 'PUT',
    body: request,
  });
}
